import React from "react";

import { Tooltip } from "@magnetic/tooltip";

import { GeographicRegion, getRegionInfo } from "./regionTypes";

import EuFlag from "src/assets/icons/flag-eu.svg?react";
import UsFlag from "src/assets/icons/flag-us.svg?react";
import "./regionFlag.scss";

interface RegionFlagProps {
  readonly geo: string | undefined;
  readonly showTooltip?: boolean;
}

type FlagComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const REGION_FLAG_ICONS: Record<GeographicRegion, FlagComponent> = {
  [GeographicRegion.US]: UsFlag,
  [GeographicRegion.EU]: EuFlag
};

/**
 * Displays a region flag icon for a given geo code.
 * Returns null if the geo code is unrecognized.
 */
export const RegionFlag = ({ geo, showTooltip = true }: RegionFlagProps) => {
  const regionInfo = getRegionInfo(geo);

  if (!regionInfo) {
    return null;
  }

  const FlagIcon = REGION_FLAG_ICONS[regionInfo.code];

  const flagElement = (
    <span className="region-flag" aria-label={regionInfo.label}>
      <FlagIcon width={22} height={15} />
    </span>
  );

  if (showTooltip) {
    return <Tooltip title={regionInfo.label}>{flagElement}</Tooltip>;
  }

  return flagElement;
};
